<script>
  import {
    insTypeOrders,
    preHandleKeys,
    diffShowKeys,
    hideKey
  } from 'base/config'
  import { formatTenThousand } from 'common/js/format'
  import Insurance from 'base/model/insurance'
  import { toggleClass } from 'common/js/dom'
  import ToggleDesc from 'components/toggleDesc/toggleDesc'
  import PbDialog from 'components/dialog/dialog'

  export default {
    components: {
      ToggleDesc,
      PbDialog
    },
    props: {
      temp: {
        type: Object,
        default: () => ({})
      },
      data: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      //
      /**
       * 显示/隐藏 责任
       * @param  {Element} dom [责任所在dom]
       */
      toggleDesc(dom) {

        dom.parentNode && toggleClass(dom.parentNode, 'ins-desc-show');
      },
      /**
       * 显示/隐藏 病种
       * @param  {Array} path [病种路径]
       */
      toggleDis(path) {
        this.$emit('disShow', path)
      },
      /**
       * 格式数据
       * @return {Object} [险种格式数据, 责任格式数据]
       */
      _normalizeData(temp) {
        // let temp = this.temp.liabilities
        let arrangeInIns = []
        let arrangeInInsType = []
        let arrangeBase = []
        let categorySort = this.temp.categorySort || 'normal'
        let insTypeOrder = insTypeOrders[categorySort]

        for (let pidx = 0, plen = temp.length; pidx < plen; pidx++) {
          let product = temp[pidx]  // 产品

          let productId = product.productId // 产品id
          let insurance = product.insuranceLiabilities  // 险种
          let insuranceLen = insurance && insurance.length
          let arrangeProduct = []
          if (!insuranceLen) continue
          for (let idx = 0; idx < insuranceLen; idx++) {
            let ins = insurance[idx]  // 险种
            let insId = ins.insuranceId // 险种id
            let insName = ins.insuranceName // 险种名字
            let liabilities = ins.liabilities // 责任
            let liabilitiesLen = liabilities && liabilities.length

            // let disease  // 险种-所有责任的病重
            if (!liabilitiesLen) continue
            for (let lidx = 0; lidx < liabilitiesLen; lidx++) {
              let liab = liabilities[lidx]  // 责任
              let liabType = liab.categoryId     // 责任类别
              let liabTypeName = liab.categoryName // 责任类别名
              let liabOrder = insTypeOrder.indexOf(liabType) // 责任排序

              if (liabOrder < 0) continue

              // 病种
              // if (liab.disease && liab.disease.title) {
              //   disease = {
              //     pidx, // 产品index
              //     idx,  // 险种
              //     lidx  // 责任
              //   }
              // }

              liab.productId = productId
              // 同责任不同产品
              if (arrangeBase[liabOrder] && Array.isArray(arrangeBase[liabOrder]['liabilities'])) {
                arrangeBase[liabOrder]['liabilities'].push(liab)
              } else {
                arrangeBase[liabOrder] = {
                  productId: productId,
                  liabilities: [liab],
                  liabTypeName
                }
              }
            }
            // arrangeProduct.push({
            //   productId,
            //   ins,
            //   disease
            // })
          }
          arrangeInIns.push(arrangeProduct)
        }

        return {
          arrangeInIns,
          arrangeInInsType,
          arrangeBase
        }
      },
      /**
       * 创建责任
       * @param  {Array} template [description]
       * @param  {Function} create
       */
      _createInsTypeVNode (template, create, diff) {

        diff = diff || [{}]

        let tpLen = template.length
        let dfLen = diff.length
        let maxLen = tpLen > dfLen ? tpLen : dfLen
        let instypeAry = []

        for (var i = 0; i < maxLen; i++) {
          let instypeBase = template[i]
          let instypeDiff = diff[i]
          let diffAry = []
          let liabTypeName = (instypeBase && instypeBase.liabTypeName) || (instypeDiff && instypeDiff.liabTypeName)

          if (!(this._isEmpty(instypeBase) && this._isEmpty(instypeDiff))) {
            let allLiabilities = [instypeBase, instypeDiff]

            for (var d = 0; d < 2; d++) {
              let product = allLiabilities[d]
              // 险种 head
              let insHeadVNode = create('h5', {
                class: 'plan-name'
              }, this.temp.diffname[d])
              let insBodyChilds
              if (product && product.liabilities) {
                insBodyChilds = this._createLiabilities(d, product.liabilities, create)
              } else {
                insBodyChilds = '--'
              }

              let insBodyVNode = create('div', {
                class: `ins-bd${insBodyChilds === '--' ? ' ins-empty' : ''}`,
              }, insBodyChilds)

              let diffVNode = create('div', {
                class: 'diff-box'
              }, [insHeadVNode, insBodyVNode])

              diffAry.push(diffVNode)
            }

            // 险种类别名
            let instypeNameVNode = create('h3', {
              class: 'instype-name',
              domProps: {
                innerHTML: `<i>${liabTypeName}</i>`
              }
            })
            diffAry.unshift(instypeNameVNode)

            let instypeVNodes = create('section', {
              class: 'instype-box'
            }, diffAry)
            instypeAry.push(instypeVNodes)
          }
        }

        return create('article', {
          class: 'des-box'
        }, instypeAry)
      },
      /**
       * 创建责任
       * @param  {Number} difIdx [产品序列，对比0、1]
       * @param  {Number} prodId [产品id]
       * @param  {Object} liab   [责任对象]
       * @return {Array}         [VNode, VNode]
       */
      _createLiabilities (difIdx, liab, create) {
        let ret = []
        let targetAry = liab
        if (!Array.isArray(liab)) {
          targetAry = [liab]
        }
        targetAry.forEach((lib) => {
          let productId = lib.productId
          diffShowKeys.forEach((sk) => {
            let libItem = lib[sk]
            if (libItem) {
              // let resultHTML = ''
              // resultHTML = this._formatLow(prodId, libItem, this.data[difIdx]);

              let resultHTML = ''
              try {
                resultHTML = this._format(productId, libItem, this.data[difIdx])
              } catch (er) {
                resultHTML = this._formatLow(productId, libItem, this.data[difIdx]);
              }

              let libVNode
              // fix 无文字时插入空的dom
              if (resultHTML) {
                // 文字预处理
                preHandleKeys.length && preHandleKeys.forEach((pre, index) => {
                  if (pre.key === sk) {
                    resultHTML = pre.value.replace(/{(.*?)}/, resultHTML)
                  }
                })
                libVNode = create('div', {
                  class: sk,
                  domProps: {
                    innerHTML: resultHTML
                  }
                })
                ret.push(libVNode)
              }
            }
          })
        })
        return ret
      },
      /**
       * 险种下的责任是否有病种
       * @param  {Array/Object} data [责任]
       * @return {Boolean}           [是否有病种]
       */
      _haveDisease (data, type) {
        let bDisease = false
        let bHideDesc = false

        let targetAry = data
        if (!Array.isArray(data)) {
          targetAry = [data]
        }
        for (let index = 0; index < targetAry.length; index++) {
          if (targetAry[index].disease && targetAry[index].disease.title) {
            bDisease = true
          }
          if (targetAry[index][hideKey]) {
            bHideDesc = true
          }
          if ((type === 0 && bDisease) || (type === 1 && bHideDesc) || (!type && bDisease && bHideDesc)) break
        }
        return {
          bDisease,
          bHideDesc
        }
      },
      /**
       * 转义，公共函数
       * @param  {[type]} templateData [pre模版，数据]
       * @return {[type]}              [模版]
       */
      _formatFnCenter(templateData) {
        var resultTemp = templateData[0];
        for (var i = 1; i < arguments.length; i++) {
          var arg = String(arguments[i]);

          // 金额显示整万
          if (templateData[i].match(/元/)) {
            arg = String(formatTenThousand(arg))
          }
          // 金额显示保留2位小数
          if (!isNaN(arg) && arg.split('.')[1]) {
            arg = arg.split('.')[1].length > 2 ? parseFloat(arg).toFixed(2) : arg
          }
          resultTemp += arg;
          resultTemp += templateData[i]
        }
        return resultTemp;
      },
      /**
       * 转义字符串模版
       * @param  {String} template [pre模版]
       * @param  {Object} data     [计算数据]
       * @return {String}          [模版]
       */
      _format(prodId, template, data) {
        let self = this
        let keys = Object.keys(data)
        let dataList
        dataList = keys.map(function (key) {
          // 根据产品id获取对应险种数据
          if (key.match(/i\d+/)) {
            if (data[key] && data[key]['p' + prodId]) {
              return data[key]['p' + prodId]
            } else {
              return new Insurance()
            }
          }
          return data[key]
        })
        // 这里使用反引号来构建模板引擎
        // let Fn = new Function
        let g = new Function(keys.join(','), 'return this._formatFnCenter `' + template + '`;')
        return g
            .apply(self, dataList)
      },
      /**
       * ios8-5c fix (_format) 方法
       */
      _formatLow(prodId, template, data) {
        let self = this;
        let temps = template.split(/\$\{(\w?[^\}]*)\}/g);
        let match = template.match(/(\\)?\{([^\{\}\\]+)(\\)?\}/g);

        let dataList
        let keys = Object.keys(data)
        dataList = keys.map(function (key) {
          // 根据产品id获取对应险种数据
          if (key.match(/i\d+/)) {
            if (data[key] && data[key]['p' + prodId]) {
              return data[key]['p' + prodId]
            } else {
              return new Insurance()
            }
          }
          return data[key]
        })
        if (match) {
          for(var i = 1; i < temps.length; i += 2){
            let ret = new Function(keys.join(','), 'return ' + temps[i] + ';').apply(self, dataList)

            // 金额显示整万
            if (temps[i + 1].match(/元/)) {
              ret = String(formatTenThousand(ret))
            }
            ret = '' + ret
            // 金额显示保留2位小数
            if (!isNaN(Number(ret)) && ret.split('.')[1]) {
              ret = ret.split('.')[1].length > 2 ? parseFloat(ret).toFixed(2) : ret
            }
            temps[i] = ret
          }
          return temps.join('')
        } else {
          return template
        }
      },
      /**
       * 空or空对象
       * @param  {Object|--}  obj [检测对象]
       * @return {Boolean}
       */
      _isEmpty(obj) {
        return !obj
      }
    },
    // 依据大类型
    render: function (createElement) {
      let { // arrangeInIns, arrangeInInsType,
        arrangeBase
      } = this._normalizeData(this.temp.liabilities)
      let arrangeDiff
      this.temp.diff && (arrangeDiff = this._normalizeData(this.temp.diff[0].liabilities).arrangeBase)

      return this._createInsTypeVNode(arrangeBase, createElement, arrangeDiff)
    }
  }
</script>